module.exports = __webpack_public_path__ + "static/img/logo2.493ffe95.png";